import type { HttpResponse } from '@cognite/sdk';
import { useSuspenseQuery } from '@tanstack/react-query';

import { useCogniteClient } from '#hooks/useCogniteClient';
import { CogniteFunctionType } from '#schema/model/api/CogniteFunctionType';

export function useCogniteFunctions() {
  const client = useCogniteClient();

  return useSuspenseQuery({
    queryKey: ['cogniteFunctions', { project: client.project }] as const,
    queryFn: async ({ queryKey: [, { project }] }) => client?.get(`/api/v1/projects/${project}/functions`),
    select: (resp: HttpResponse<{ items?: object[] }> | undefined) =>
      CogniteFunctionType.array().parse(resp?.data?.items),
  });
}
